"use strict";
const SIMPLIFY_SELECTOR = '[data-action="translation-actions#simplify"]';
const LISTING_SCOPE_PATTERN = /^#(proposal|debate|blog-post|meeting)-listing-item-(\d+)$/;
const LISTING_TYPE_MAP = { "proposal": "proposal", "debate": "debate", "blog-post": "blog_post", "meeting": "meeting" };
function summariseLabel() {
  var _a;
  return ((_a = document.querySelector('meta[name="decidim-insights-summarise-label"]')) == null ? void 0 : _a.content) || "Summarise";
}
function nextIsSummarise(simplifyBtn) {
  var _a;
  return (_a = simplifyBtn.nextElementSibling) == null ? void 0 : _a.hasAttribute("data-summarise");
}
function restyle(btn) {
  btn.classList.add("ideal-translations-action-btn");
  btn.classList.remove("button__sm", "button__text-secondary", "button__text", "button__transparent-secondary");
  const svg = btn.querySelector("svg");
  if (svg && svg.previousElementSibling) btn.insertBefore(svg, btn.firstChild);
}
function integrateCommentButton(btn) {
  const actions = btn.closest(".comment__actions");
  const simplifyBtn = actions.querySelector(SIMPLIFY_SELECTOR);
  if (!simplifyBtn) return;
  btn.classList.add("ideal-translations-action-btn");
  btn.classList.remove("button__sm", "button__text-secondary", "button__text");
  if (simplifyBtn.nextElementSibling !== btn) {
    simplifyBtn.insertAdjacentElement("afterend", btn);
  }
}
function injectListingButton(simplifyBtn, resourceType, resourceId) {
  const btn = simplifyBtn.cloneNode(true);
  btn.removeAttribute("data-action");
  btn.setAttribute("data-summarise", "");
  btn.dataset.resourceType = resourceType;
  btn.dataset.resourceId = resourceId;
  const use = btn.querySelector("use");
  ["href", "xlink:href"].forEach((attr) => {
    const value = use == null ? void 0 : use.getAttribute(attr);
    if (value) use.setAttribute(attr, value.replace(/#ri-[\w-]+$/, "#ri-file-text-line"));
  });
  const span = btn.querySelector("span");
  if (span) span.textContent = summariseLabel();
  simplifyBtn.insertAdjacentElement("afterend", btn);
}
function integrateMainButton(simplifyBtn) {
  if (!nextIsSummarise(simplifyBtn)) {
    const candidate = Array.from(document.querySelectorAll("[data-summarise]")).find((btn) => !btn.closest(".comment__actions") && btn.dataset.resourceType !== "comment" && !(btn.previousElementSibling && btn.previousElementSibling.matches(SIMPLIFY_SELECTOR)));
    if (!candidate) return;
    restyle(candidate);
    simplifyBtn.insertAdjacentElement("afterend", candidate);
  }
  integrateMainAnalytics(simplifyBtn.nextElementSibling);
}
function integrateMainAnalytics(summariseBtn) {
  if (!(summariseBtn == null ? void 0 : summariseBtn.hasAttribute("data-summarise"))) return;
  const analyticsBtn = Array.from(document.querySelectorAll("[data-resource-analytics]")).find((btn) => !btn.closest(".comment__actions"));
  if (!analyticsBtn || summariseBtn.nextElementSibling === analyticsBtn) return;
  restyle(analyticsBtn);
  summariseBtn.insertAdjacentElement("afterend", analyticsBtn);
}
function integrate() {
  document.querySelectorAll(".comment__actions [data-summarise]").forEach(integrateCommentButton);
  let mainHandled = false;
  document.querySelectorAll(SIMPLIFY_SELECTOR).forEach((simplifyBtn) => {
    if (simplifyBtn.closest(".comment__actions")) return;
    const root = simplifyBtn.closest('[data-controller="translation-actions"]');
    const scope = (root == null ? void 0 : root.dataset.translationActionsScopeSelectorValue) || "";
    const listing = scope.match(LISTING_SCOPE_PATTERN);
    if (listing) {
      if (!nextIsSummarise(simplifyBtn)) {
        injectListingButton(simplifyBtn, LISTING_TYPE_MAP[listing[1]], listing[2]);
      }
    } else if (!mainHandled) {
      mainHandled = true;
      integrateMainButton(simplifyBtn);
    }
  });
}
let scheduled = false;
function schedule() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    integrate();
  });
}
let started = false;
function start() {
  if (started) return;
  started = true;
  integrate();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
}
document.addEventListener("DOMContentLoaded", start);
document.addEventListener("turbo:load", integrate);
if (document.readyState !== "loading") start();
